null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/typelevel/cats/v2.1.0/kernel/src/main/scala/cats/kernel/Monoid.scala